import { action } from 'satcheljs';

export interface FeedbackRibbonClickProps {
    SessionId: string;
    Feature: string;
    RibbonResponse: string;
    SubFeature?: string;
    Metadata?: string;
    clickCallback?: () => void;
}

export const logFeedbackRibbonClickResponse = action(
    'logFeedbackRibbonClickResponse',
    (feedbackRibbonClickResponse: FeedbackRibbonClickProps) => feedbackRibbonClickResponse
);
